const viewBookingES = {
	header: {
		eyebrow: "Tu reserva",
		title: "Resumen de la reserva",
	},
	status: {
		confirmed: "Confirmada",
		cancelled: "Cancelada",
		completed: "Completada",
		in_progress: "En progreso",
		pending: "Pendiente",
		no_show: "No asistió",
		rescheduled: "Reprogramada",
	},
	details: {
		services: "Servicios",
		staff: "Con",
		date: "Fecha",
		time: "Hora",
		duration: "{{count}} min",
		total: "Total",
		location: "Ubicación",
	},
	sidebar: {
		location: "Ubicación",
		getDirections: "Cómo llegar",
	},
	manage: {
		title: "Gestionar reserva",
		rescheduleInfo: "¿Necesitas otro horario o ya no puedes asistir?",
		rescheduleBtn: "Reprogramar",
		cancelBtn: "Cancelar reserva",
		backBtn: "Volver",
	},
	confirm: {
		title: "¿Cancelar cita?",
		text: "Esta acción no se puede deshacer. ¿Seguro que quieres cancelar tu cita?",
		back: "Volver",
		confirm: "Sí, cancelar",
	},
	reviewBlock: {
		yourReview: "Tu reseña",
		edit: "Editar reseña",
		anonymous: "Anónimo",
		noComment: "Sin comentario.",
		ctaTitle: "¿Cómo te fue?",
		ctaText: "Tu calificación ayuda a otras personas a encontrar los buenos lugares — solo toma un momento.",
		ctaBtn: "Dejar una reseña",
	},
	misc: {
		confirmationEmail: "Se envió un correo de confirmación a",
		reviewSubmitted: "¡Gracias! Tu reseña se envió correctamente.",
		reviewUpdated: "¡Listo! Tu reseña fue actualizada.",
	},
	errors: {
		load: "No pudimos cargar tu reserva. Inténtalo de nuevo.",
		cancel: "No pudimos cancelar tu reserva. Inténtalo de nuevo.",
		reschedule: "No pudimos abrir la reprogramación. Inténtalo de nuevo.",
		reload: "No pudimos actualizar los datos de tu reserva.",
	},
};
export default viewBookingES;
